import { useEffect } from 'react';

function useMountEffect(func: () => void) {
  return useEffect(func, []);
}

export default useMountEffect;
